import moment from 'moment';
// import usePlatformUsers from '../../hooks/analytics/usePlatformUsers';
import useMockPlatformUsers from '../../hooks/analytics/useMockPlatformUsers';
import DailyBarChart from './DailyBarChart';
import { TimeConversions } from '../../config/constants';
import { calculatePercentageDifference } from '../../helpers';

const today = moment();
const oneWeekAgo = today.clone().subtract(7, 'days').unix();

const DailyNewUsers = () => {
    const { platformUsers, isLoading } = useMockPlatformUsers();

    const dailyNewUsers = platformUsers
        ? () => {
              const dayOfWeekTotal = platformUsers
                  .filter(
                      ({ firstTradedTimestamp }) => firstTradedTimestamp >= oneWeekAgo
                  )
                  .reduce(
                      (acc, cur) => {
                          const currentDay = Math.floor(
                              (today.unix() - cur.firstTradedTimestamp) /
                                  TimeConversions.SECONDS_PER_DAY
                          );

                          const day =
                              moment().subtract(currentDay, 'day').isoWeekday() - 1;

                          acc[day] = acc[day] + 1;

                          return acc;
                      },
                      [0, 0, 0, 0, 0, 0, 0]
                  )
                  .map((value, index) => ({
                      value,
                      label: moment.weekdaysShort(index + 1),
                  }));

              const dayOfWeek = today.isoWeekday() - 1;
              const previousDayOfWeek = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

              const dayOfWeekValue = dayOfWeekTotal[dayOfWeek].value;
              const previousDayOfWeekValue = dayOfWeekTotal[previousDayOfWeek].value;

              const dailyDifference = calculatePercentageDifference(
                  dayOfWeekValue,
                  previousDayOfWeekValue
              );

              return {
                  dayOfWeekTotal,
                  dailyDifference,
              };
          }
        : undefined;

    return (
        <DailyBarChart
            className='daily-new-users'
            title='24h New Users'
            dailyDifference={dailyNewUsers?.().dailyDifference}
            dayOfWeekTotal={dailyNewUsers?.().dayOfWeekTotal}
            isLoading={isLoading}
        />
    );
};

export default DailyNewUsers;
